import { ReactNode, useEffect } from 'react';
import { useAuth, withAuthenticationRequired } from 'react-oidc-context';

type Props = {
  children: ReactNode;
};

const PrivateRoute = ({ children }: Props) => {
  const { error, signinRedirect } = useAuth();

  useEffect(() => {
    if (!error) return;
    signinRedirect().catch((err: unknown) => {
      console.error('signinRedirect after auth error failed', err);
    });
  }, [error, signinRedirect]);

  if (error) {
    return <div>Redirecting...</div>;
  }

  return <div>{children}</div>;
};

export default withAuthenticationRequired(PrivateRoute, {
  OnRedirecting: () => {
    return <div>Redirecting...</div>;
  },
});
